'use client'
import { useEffect, useState } from 'react';

export default function ScrollProgress() {
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    const scrollY = window.scrollY; // Current scroll position
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight; // Total scrollable height
    const scrollPercent = (scrollY / documentHeight) * 100; // Scroll progress in percentage
    setScrollPosition(scrollPercent);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up event listener on unmount
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-1 bg-career-dark-50 z-50">
      <div
        className="h-1 bg-purple-500"
        style={{ width: `${scrollPosition}%` }}
      ></div>
    </div>
  );
}